import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const LabSolution = () => {
  return (
    <section id="lab-solution" className="landing lab-landing">
      <Helmet>
        <title>Laboratory Information System (LIS) & LIMS India — Mediway Nextgen</title>
        <meta name="description" content="Advanced LIS software for pathology labs and diagnostic centers in India. Barcode sample tracking, bidirectional machine interfacing, and automated reporting." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com/solutions/for-diagnostic-labs" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            'name': 'Laboratory Information System (LIS)',
            'description': 'Full-stack LIMS platform for diagnostic labs featuring barcode tracking, digital approval sign-offs, and patient email report delivery.',
            'brand': 'Mediway Nextgen',
            'url': 'https://mediwaynextgen.wayug.com/solutions/for-diagnostic-labs',
            'applicationCategory': 'LaboratoryApplication'
          })}
        </script>
      </Helmet>

      <div className="container">
        <header className="section-header">
          <h2 className="section-title">LIS Software for Diagnostic &amp; Pathology Labs</h2>
          <p className="section-subtitle">Transform lab turnaround time (TAT) with integrated barcode logistics, electronic approval workflows, and real-time analytics.</p>
        </header>

        <div className="service-content">
          <div className="service-header">
            <div className="service-icon">🔬</div>
            <div className="service-info">
              <h3 className="service-title">Intelligent Lab Operations</h3>
              <p className="service-description">Eliminate typing errors and missing samples. Automatically funnel testing orders from the patient registry to barcodes, lab machines, and digital reports.</p>
            </div>
          </div>

          <div className="service-body">
            <div className="service-features">
              <h4>Core LIMS Features</h4>
              <ul className="features-list">
                <li className="feature-item"><span className="feature-check">✓</span><span>Automated Barcode generation &amp; scan</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Bidirectional Machine Interfacing hooks</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Pathologist digital sign-off &amp; QA queue</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Direct Email / WhatsApp report delivery</span></li>
              </ul>
            </div>

            <div className="service-benefits">
              <h4>Diagnostic Benefits</h4>
              <div className="benefits-grid">
                <div className="benefit-card"><div className="benefit-icon">⚡</div><span>Reduce TAT by 50%</span></div>
                <div className="benefit-card"><div className="benefit-icon">🛑</div><span>Zero manual data entry</span></div>
                <div className="benefit-card"><div className="benefit-icon">📩</div><span>Instant patient access</span></div>
              </div>
            </div>
          </div>

          <div className="service-actions">
            <Link to="/contact" className="btn btn-primary">Request LIS Demo</Link>
            <Link to="/services" className="btn btn-secondary">View Lab Module</Link>
          </div>
        </div>
      </div>

      <div className="services-background">
        <div className="background-pattern"></div>
      </div>
    </section>
  );
};

export default LabSolution;
